import React, { Component } from 'react';
import { Redirect, Link, history } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class AddTaskEr extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            title: '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {},
            errors: {},
            message: '',
            last_week_date:[],
            week:'0'
        }
        this.insertSnippet = this.insertSnippet.bind(this);
        this.onChange = this.onChange.bind(this);
        this.weekchange= this.weekchange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    
    goBack() {
        window.location.href = '/snippets';
    }

    insertSnippet(e) {
        document.getElementById("add_request").innerHTML = "Sending....";
        var nodes1 = document.querySelectorAll('input[type="text"].multi_title');
        const fd = new FormData;
        for (let i in nodes1) {
            let value = nodes1[i].value;
            if (value !== null && typeof value !== "undefined" && value.trim() !== "") {
                fd.append("multi_title[]", value);
            }
        }
        document.getElementById("add_request").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fd.append('week', JSON.stringify(this.state.week));
        fetch(this.state.apiUrl + '/ErRest/InsertSnippet/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/status/' + this.props.match.params.status, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_request").innerHTML = "Submit";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.props.history.push('/snippets');
                        document.getElementById("add_request").disabled = false;
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                    document.getElementById("add_request").disabled = false;
                }
            })
    }

    onChange(event) {
        let fields = this.state.fields;
        fields[event.target.name] = event.target.value;
    }
    weekchange(event) {
        this.setState({
        week: event.target.value,
         }, function () {
       });
    }

    GetSnippetValues() {
        fetch(this.state.apiUrl + '/ErRest/GetSnippetValues/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    last_week_date: findresponse.date,
                })
            })
    }

    componentDidMount() {
        document.title = "Intranet | Add Snippet";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        this.GetSnippetValues();

        $(document).ready(function () {
            $('.upload_btn label').click(function () {
                $('.upload_btn .inputfile').click();
            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();

                $input.on('change', function (e) {
                    var fileName = '';

                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });

                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });


            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var files = e.target.files,
                        filesLength = files.length;
                });

            } else {
                alert("Your browser doesn't support to File API")
            }

            var max_fields = 10;
            var wrapper = $("#extra_added_snippet_inputs");
            var x = 1;
            $(document).on("click", ".add_form_field", function (e) {
                e.preventDefault();
                if (x < max_fields) {
                    x++;
                    let currentVal = $("#first_value").val();
                    currentVal = (currentVal.trim() !== "") ? currentVal : '';
                    $("#first_value").val('');
                    $(wrapper).append('<div class="snipet_bar"><input type="text" name="multi_title[]" value="' + currentVal + '" class="multi_title form-control" /><i class="far fa-minus-circle delete color-sky"></i></div>'); //add input box
                }
                else {
                    alert('You Reached the limits')
                }
            });

            $(wrapper).on("click", ".delete", function (e) {
                e.preventDefault(); $(this).parent('.snipet_bar').remove(); x--;
            })
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Snippets" brecum_page="Add Snippets" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob"><HeaderMob page_name="Add Snippets" /></div>
                        <div class="form-group"></div>
                        <div class="top-row-form">
                            
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                    <label for="title">Week</label>
                                        <div class="filter">
                                 <select  id="week" class="form-control" name="week" onChange={this.weekchange}>
                                     {
                                         this.state.last_week_date.map((dynamicData, key) =>
                                     <option value={dynamicData.key}>{dynamicData.value}</option>
                                                 )
                                     }
                                 </select>
                                 <i class="fal fa-angle-down"></i>
                                </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                <div class="snipet_box col-md-8">
                                        <label for="title" >Snippets</label>
                                        <div id='extra_added_snippet_inputs'></div>
                                        <div class="snipet_bar" >
                                            <input type="text" id='first_value' name="multi_title[]" class="multi_title form-control" /><i class="far fa-plus-circle color-sky add_form_field"></i>
                                    </div>
                                </div>
                                </div>
                                <span className="error">{this.state.message}</span>
                            </div>
                        </div>
                        <button type="submit" name="add_request" id="add_request" class="btn btn-sky mob-btn" onClick={() => this.insertSnippet()}>Submit</button>
                        <button type="button" className="btn btn-blue hidden-sm" onClick={() => this.goBack()} >Back</button>
                    </div>
                </div>
            </div>
        )
    }
}
export default AddTaskEr;


// WEBPACK FOOTER //
// ./src/components/er/AddTaskEr.js